const hoverArrow = () => {
	document.addEventListener('DOMContentLoaded', function () {
        const hover = document.querySelectorAll('.hover')
        hover.forEach(function(el){
            el.addEventListener('mouseover', function(){
                el.classList.add('hover-arrow')
            })
            el.addEventListener('mouseleave', function(){
                el.classList.remove('hover-arrow')
            })
        })
	})
}

export default hoverArrow